import {questionConstants, uriConstants} from '../../constants'
import {defaultService, questionService} from '../../services'
import {errorMessages} from '../../messages'
import {alertActions} from '../'

export const questionActions = {
	load,
	select,
	detail,
	regis,
	edit,
	del,
	checkPwd,
	registReset,
	showPwdPopup,
	showTerms,
}

/*******************
  method 반드시 이렇게..

  GET    = Read
  POST   = Create
  PUT    = Update
  DELETE = Delete
 ********************/

/*********
 등록
 *********/

function regis(params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.REGISTER_REQUEST))

		questionService.regis(params)
			.then(
				response => {
					dispatch(apiAction(questionConstants.REGISTER_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.REGISTER_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/*********
 수정
 *********/

function edit(params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.REGISTER_REQUEST))

		questionService.edit(params)
			.then(
				response => {
					dispatch(apiAction(questionConstants.REGISTER_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.REGISTER_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/*********
 목록조회
 **********/

function load(params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.LOAD_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.QUESTION + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(questionConstants.LOAD_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.LOAD_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/******
 삭제
 *****/

function del(params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.DELETE_REQUEST))
		const paramStr = `/${params.seq}?token=${params.token}`;

		defaultService.handleService({
			method: 'delete',
			endPoint: uriConstants.API_URI + uriConstants.QUESTION + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(questionConstants.DELETE_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.DELETE_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}


/******
  상세조회
 *****/

function detail(seq, params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.DETAILS_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.QUESTION + '/' + seq + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(questionConstants.DETAILS_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.DETAILS_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/******
 비밀번호 확인
 *****/

function checkPwd(seq, params) {
	return async dispatch => {
		dispatch(apiAction(questionConstants.PWD_REQUEST))
		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)
		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.QUESTION_PWD + '/' + seq + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(questionConstants.PWD_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(questionConstants.PWD_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}


/*********
 셀렉트
 **********/

function select(params) {
	return async dispatch => {
		dispatch(request())
	}

	function request() {
		return {
			type: questionConstants.SELECT_REQUEST,
			params
		}
	}
}

/**
 * 게시글 등록 완료후 처리
 */
function registReset() {
	return {
		type: questionConstants.REGISTER_RESET,
	}
}

/**
 * UI 표시관련 함수
 * @param isShow
 * @returns {{type: string, isShow}}
 */
function showTerms(isShow) {
	return {
		type: questionConstants.SHOW_TERMS,
		isShow: isShow
	}
}

function showPwdPopup(isShow, pwdType, selectSeq = null) {
	return {
		type: questionConstants.SHOW_PWD_POPUP,
		isShow: isShow,
		pwdType: pwdType,
		selectSeq: selectSeq,
	}
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
	let resultObj = {type};
	response && (resultObj.response = response)
	return resultObj;
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
	return alertActions.error({
		title: null,
		message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
	})
}
